import React from "react";
import AcademyBanner from "./AcademyBanner";
import Partners from "./Partners";

export const Academy = () => (
    <div className="franchise-academy-section">
        <AcademyBanner />
        <Partners />
    </div>
);

export default Academy;
